import React from 'react';
import PropType from 'prop-types';
import MyFavourites from './MyFavourites';
import MyAccount from '@deporvillage/my-account-component';
import CartDisplay from '@deporvillage/cart-display-component';

import styles from './HeaderActions.module.scss';

const HeaderActions = ({ items, amount, totalItems, user, onClick, onScroll, onChange, isOpened }) => {
    const { userName, isLogged, favorites } = user;

    return (
        <div className={ styles['header-actions-component'] }>
            <div className={`${ styles['wrapper'] } ${ styles['wrapper-my-account'] }`}>
                <MyAccount
                    name={ userName }
                    logged={ isLogged }
                    onClick={ (e) => onClick && onClick(e) }
                    onChange={ (e) => onChange && onChange(e) }
                />
            </div>
            <div className={ styles['wrapper'] }>
                <MyFavourites favorites={favorites} logged={isLogged} />
            </div>
            <div className={ styles['wrapper'] }>
                <CartDisplay
                    items={ items }
                    amount={ amount }
                    totalItems={ totalItems }
                    onClick={
                        /* istanbul ignore next */
                        (e) => onClick && onClick(e)
                    }
                    onScroll={
                        /* istanbul ignore next */
                        (e) => onScroll && onScroll(e)
                    }
                    isOpened={ isOpened }
                />
            </div>
        </div>
    );
};

HeaderActions.propTypes = {
    items: PropType.array,
    amount: PropType.number,
    totalItems: PropType.number,
    user: PropType.shape({
        userName: PropType.string,
        isLogged: PropType.bool,
        sessionId: PropType.string,
        favorites: PropType.number,
    }),
    onClick: PropType.func,
    onScroll: PropType.func,
    onChange: PropType.func,
    isOpened: PropType.bool,
};

export default HeaderActions;
export { MyFavourites };
